// extracted by mini-css-extract-plugin
module.exports = {"base":"collectionNameTabs-m__base__SHJM9"};